import { useEffect } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { useParams } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import { Form } from '../../components/form/Form'
import { Header } from '../../components/Header'
import { useAppData } from '../../hooks/useAppData'
import { GlobalStyles } from '../Home/styles'
import { ListOfCourses } from './ListOfCourses'
import { StyledApplicationContainer } from './styles'

export const ApplicationPage = () => {
  let { id } = useParams()

  const { additionalIntakes, intakeName } = useAppData()
  const additionalIntakesCount = additionalIntakes?.length ?? 0

  const additionalIntakesText = `+ ${additionalIntakesCount} Additional Course${additionalIntakesCount > 1 ? 's' : ''}`

  const tooltip = ListOfCourses(additionalIntakes ?? [])

  useEffect(() => {
    ReactTooltip.rebuild()
  }, [tooltip])

  return (
    <StyledApplicationContainer>
      <GlobalStyles greyColor />
      <Header title={intakeName ?? ''}>
        <>
          {!!additionalIntakesCount && (
            <span
              className="application-subtext"
              data-tip={renderToStaticMarkup(tooltip)}
              data-html={true}
              data-place="bottom"
              data-effect="solid"
            >
              {additionalIntakesText}
            </span>
          )}
        </>
      </Header>

      <Form
        formGuid={id}
        isContact={false}
      />
    </StyledApplicationContainer>
  )
}
